import { validateArrayCustom } from '../../Helper'

const createCantainerErrorMsgStructure = (error, idx) => {
    return Object?.entries(error)?.reduce((prev, [errKey, errVal]) => {
        return { ...prev, [`container${idx + 1}_${errKey}`]: errVal[0] ? { msg: `Container 00${idx + 1} :: ${errVal[0]}` } : "" }
    }, {})
}

export const validateContainers = (containerList, validationPattern) => {
    let errorList = validateArrayCustom(containerList, validationPattern, createCantainerErrorMsgStructure)
    return errorList
}

export const invoiceDataConversion = (invoice) => {
    let invoiceList = invoice?.invoiceList || [];
    let invoiceData = Object.values(invoiceList).reduce((prev, curr) => {
        let lineItems = curr?.merchandiseIds?.map((itm) => invoice?.merchandise?.[itm]) || []
        return [...prev, { ...curr, lineItems }]
    }, [])
    return invoiceData || []
}